/**
 *
 * Asynchronously loads the WorkflowFilterPopup component
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
